{
  "addSensor": "Add Sensor",
  "linearMovePathTitle": "Linear Move Path",
  "centerPivotPathTitle": "Center Pivot Outline",
  "addSensorAlreadyAddedWithSensorNameErrorMessage": "This device already has a {{sensorName}} sensor configured. Please contact FarmHQ support if you need assistance. ",
  "addSensorCannotAddToExistingErrorMessage": "This sensor cannot be added to an existing configuration. Please contact FarmHQ support if you need assistance. ",
  "addSensorInstructions": "Select a sensor to add to your device's configuration.",
  "addSensorNotCompatibleErrorMessage": "This sensor is not compatible with the device's configuration. Please contact FarmHQ support if you need assistance. ",
  "addSensorTitleWithSensorName": "Add {{sensorName}} Sensor Configuration",
  "chooseInstallationType": "Choose Installation Type",
  "choosePressureSensorModelInstructions": "Choose the pressure sensor model that is installed on your device.",
  "choosePumpTypeInstructions": "Choose the option that best describes your equipment and installation.",
  "choosePumpTypeTitle": "Select Pump Type",
  "choosePumpType_pump_off_only": {
    "description": "Shutdown-only pump (Diesel, E-stop electrical)",
    "label": "Off-Only Pump"
  },
  "choosePumpType_pump_on_off": {
    "description": "Single Contact On/Off (Stage 4 Diesel, Electric)",
    "label": "On/Off Pump"
  },
  "choosePumpType_pump_vfd": {
    "description": "VFD Pump with speed control",
    "label": "VFD Pump"
  },
  "chooseSensorPortInstructionsWithSensorName": "Choose the sensor port where the {{sensorName}} sensor is installed.\n\nNote that incorrectly matched sensor ports will prevent your device from producing correct readings. If you are unsure, please contact FarmHQ support.",
  "chooseSensorPortStageTitle": "Select Sensor Port",
  "clickSensorToManage": "Click a sensor to view or manage its configuration.",
  "clickSensorToManageMobile": "Tap a sensor to view or manage its configuration.",
  "configurationInfoTitle": "Configuration Information",
  "configurationRequiredMessage": "Before taking this action, you must enter configuration information for this device.",
  "configurationRequiredTitle": "Configuration Required",
  "configuredSensors": "Configured Sensors",
  "confirm": "Confirm",
  "customizeDeviceNameInstructions": "You can give your device a nickname to help you identify it. This name will be displayed in the FarmHQ app. If you leave this field blank, the device will be named after its product alias.",
  "customizeDeviceNameStageTitle": "Customize Device Name",
  "deleteSensor": "Delete Sensor",
  "deleteSensorImpactFunctionalityWarning": "This may have negative impacts on your device's functionality. \n\nIf you are unsure about what you are doing, please contact FarmHQ support.",
  "deleteSensorSensorIsRequiredMessage": "This sensor is required in order for your device to function and cannot be deleted. If you need support, please contact FarmHQ.",
  "deleteSensorTitleWithSensorName": "Confirm Delete {{sensorName}} Configuration",
  "deviceInstallationType": "Installation Type",
  "deviceName": "Device Name",
  "deviceNameInputLabel": "Device Name",
  "deviceNameInputPlaceholder": "Enter a name for this device",
  "deviceSetup": "Device Setup",
  "doesItHaveAFlowSensor": "Does the device have a flow sensor installed?",
  "doesItHaveAPressureSensor": "Does the device have a pressure sensor installed?",
  "edit": "Edit",
  "editSensorField": "Edit Sensor Field",
  "forbidden": "Forbidden",
  "hardwareGeneration": "Hardware Generation",
  "helpContentBodyText": "Device configurations are used to set up your device with the correct sensors and settings. This ensures that your device can accurately track and report data, and can be used in automations and notifications.",
  "hintWithColon": "Hint:",
  "hose": "Hose",
  "linkTo": "Configuration",
  "manageSensor": "Manage Sensor",
  "manageSensorWithSensorName": "Manage {{sensorName}} Sensor",
  "newConfiguration": "New Configuration",
  "newDeviceConfiguration": "New Device Configuration",
  "newReelConfiguration": "New Reel Configuration",
  "noConfiguredSensorsMessage": "No sensors configured for this device.",
  "notNow": "Not Now",
  "nozzle": "Nozzle",
  "pathConfigurationLinearTitle": "Linear Path Configuration",
  "pathConfigurationPivotTitle": "Pivot Configuration",
  "pc1PumpSetupStageTitle": "PC1 Pump Configuration (Legacy)",
  "pressureSensor": "Pressure Sensor",
  "pressureSensorModelNameSoway500": "Soway 0-500psi",
  "pressureSensorModelNameMeas": "MEAS",
  "pressureSensorModelNameOther": "Other",
  "pressureSensorModelNameSoway": "Soway",
  "pressureSensorModelNameTrafag": "Trafag",
  "pressureSensorModelStageTitle": "Choose Pressure Sensor Model",
  "pressureThresholdsHelpText": "Pressure thresholds help determine when a device with a pressure center if pumping more or less water than expected.",
  "pressureThresholdsStageTitle": "Pressure Thresholds",
  "pumpType": "Pump Type:",
  "removeFromFarmAreYouSure": "Are you sure you want to remove this device from this farm account?",
  "removeFromFarmLinkTo": "Remove from Farm",
  "removeFromFarmTitle": "Confirm Device Removal",
  "removeFromFarmWarning": "The device will be factory reset and will no longer appear in this account. This cannot be undone.",
  "rename": "Rename",
  "renameDevice": "Rename Device",
  "renameThisDevice": "Rename this device",
  "resetDeviceAreYouSure": "Are you sure you want to restore this device to defaults?",
  "resetDeviceLinkTo": "Factory Reset",
  "resetDeviceTitle": "Confirm Device Reset",
  "resetDeviceYouWillLoseConfigurations": "You will lose any sensor configurations and any other customizations. This cannot be undone.",
  "resetDeviceYouWillLoseTriggers": "All and device pairs, notifications, and automations will also be deleted.",
  "reviewAndSubmitInstructions": "Your device will be configured with the following settings. Review them and submit to save changes.",
  "selectPressureSensorToContinue": "Select a pressure sensor model to continue. If you are unsure, please contact FarmHQ support.",
  "sensorPortHint": "Make sure the sensor port is correctly identified. Switched sensor ports can lead to incorrect readings.",
  "sensors": "Sensors",
  "setPressureThresholdInstructions": "Set pressure thresholds to determine when your equipment is pumping more or less water than expected.",
  "setUp": "Set Up Device",
  "setUpCenterPivot": "Center-Pivot Setup",
  "setUpDevice": "Set Up Device",
  "setUpLinearMove": "Linear-Move Setup",
  "setUpPump": "Pump Setup",
  "setUpReel": "Reel Setup",
  "setUpReelDescription": "Enter your reel's calibration information to ensure accurate tracking of irrigation, ETA, and other metrics.",
  "setUpSoftHoseTraveler": "Soft-Hose Traveler Setup",
  "setUpTravelerSoft": "Soft-Hose Traveler Setup",
  "setUpValve": "Valve Setup",
  "spool": "Spool",
  "thisDeviceAlreadyHasThatSensorWithSensorName": "This device already had an active {{sensorName}} configuration. To edit or delete it, select it from the list.",
  "title": "Configuration",
  "unconfiguredDeviceWarning": "This device is not configured.",
  "updateConfigurationDataLossWarning": "The device may also experience temporary data loss while the changes sync.",
  "updateConfigurationSwitchOnToOffWarning": "Updating the device's configuration will cause the switch to turn off if it is currently on.",
  "vfdTrackingSpeedsStageTitle": "VFD Tracking Speeds",
  "wheelDiameterMmInstructions": "Measure the wheel diameter and enter it here.",
  "wheelDiameterStageTitle": "Wheel Diameter",
  "wheelMagnetsStageTitle": "Wheel Magnets",
  "wheelNMagnetsInstructions": "Enter the number of magnets installed on the wheel.",
  "wheelSensorPortInstructions": "Where is the wheel sensor installed?",
  "wheelSensorPortStageTitle": "Wheel Sensor Port",
  "wheelStoppedTimeoutInstructions": "How long the device should wait without detecting wheel movement before reporting the wheel as stopped.",
  "wheelStoppedTimeoutStageTitle": "Wheel Stopped Timeout",
  "wouldYouLikeToSetLinearPath": "Would you like to set the linear path now?"
}
